import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.125 1.25h-.75V0h-1.25v1.25h-8.25V0h-1.25v1.25h-.75A1.877 1.877 0 0 0 0 3.125v11C0 15.159.841 16 1.875 16h12.25A1.877 1.877 0 0 0 16 14.125v-11a1.877 1.877 0 0 0-1.875-1.875m.625 12.875c0 .345-.28.625-.625.625H1.875a.626.626 0 0 1-.625-.625v-8.25h13.5zm0-9.5H1.25v-1.5c0-.345.28-.625.625-.625h.75v1.25h1.25V2.5h8.25v1.25h1.25V2.5h.75c.345 0 .625.28.625.625z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9 7v6H7.927V8.114H7V7z"
    }, null, -1)
  ]))]))
}
export default { render: render }